// Everything the platform mounts for intake, in one place.

import { Navigate } from "react-router-dom";
import type { ModuleScreens } from "../../components/chrome/screens";
import type { TrailStep } from "../../components/chrome/trail";
import IntakeStart from "./pages/IntakeStart";
import IntakePublicStart from "./pages/IntakePublicStart";
import { IntakeHub } from "./pages/IntakeHub";
import { IntakeWizard } from "./pages/IntakeWizard";
import { IntakeInterview } from "./pages/IntakeInterview";
import { IntakeSubmission } from "./pages/IntakeSubmission";
import { IntakeTemplateEditor } from "./pages/IntakeTemplateEditor";

const INTAKE: TrailStep = { label: "Intake", to: "/intake" };

export const intakeScreens: ModuleScreens = {
  id: "intake",
  routes: [
    // The questionnaire a client opens from the office's link, and the
    // public door to the same form: their own credential, no firm chrome.
    { path: "/intake/start", element: <IntakeStart />, wrapper: "public" },
    { path: "/intake/new", element: <IntakePublicStart />, wrapper: "public" },
    { path: "/intake", element: <IntakeHub />, wrapper: "chrome" },
    { path: "/intake/manual", element: <IntakeWizard />, wrapper: "chrome" },
    { path: "/intake/interview/:sessionId", element: <IntakeInterview />, wrapper: "chrome" },
    { path: "/intake/submission/:sessionId", element: <IntakeSubmission />, wrapper: "chrome" },
    { path: "/intake/questionnaire", element: <IntakeTemplateEditor />, wrapper: "chrome" },
    // A path that moved: kept so an old bookmark still lands.
    {
      path: "/settings/intake",
      element: <Navigate to="/intake/questionnaire" replace />,
      wrapper: "chrome",
    },
  ],
  tiles: [{ id: "intake", icon: "+", label: "Intake", to: "/intake" }],
  trails: [
    { path: "/intake", steps: [{ label: "Intake" }] },
    { path: "/intake/manual", steps: [INTAKE, { label: "Manual" }] },
    { path: "/intake/interview/:sessionId", steps: [INTAKE, { label: "Interview" }] },
    { path: "/intake/submission/:sessionId", steps: [INTAKE, { label: "Answers" }] },
    { path: "/intake/questionnaire", steps: [INTAKE, { label: "Questionnaire" }] },
    { path: "/settings/intake", steps: [INTAKE, { label: "Questionnaire" }] },
  ],
};
